export default {
  getHead: () => {
    return [{ name: "회사명", style: { width: "24%" } }, { name: "발주자" }, { name: "작성자" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 회사명
      case 1:
        return func.getContent(value).inputC_5; // 발주자
      case 2:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      case 3:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    switch (nav.value.searchType) {
    case "회사명":
      returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
      break;
    case "발주자":
      returnData.push("content$body.inputC_5*%[:default_skw]%");
      break;
    case "작성부서":
      returnData.push("content$body.stdInfo.com_name*%[:default_skw]%");
      break;
    case "작성자":
      returnData.push("content$body.stdInfo.writer_name*%[:default_skw]%");
      break;
    }

    return returnData;
  },
};
